module.exports = __webpack_public_path__ + "764290d12b237640d7e20b37a4b480f7.svg";